import { render, staticRenderFns } from "./MilkTeaSetting.vue?vue&type=template&id=08bdc590&scoped=true&"
import script from "./MilkTeaSetting.vue?vue&type=script&lang=js&"
export * from "./MilkTeaSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bdc590",
  null
  
)

export default component.exports